import Swiper, { Lazy, Navigation } from "swiper";

class TestimonialsSlider {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const self = this;

    new Swiper(this.wrapper.children(".swiper")[0], {
      modules: [Lazy, Navigation],
      slidesPerView: 1,
      spaceBetween: 24,

      breakpoints: {
        800: {
          slidesPerView: 1.5,
        },
        1200: {
          slidesPerView: 2,
        },
      },

      navigation: {
        nextEl: this.wrapper.find(".swiper-nav--next")[0],
        prevEl: this.wrapper.find(".swiper-nav--prev")[0],
      },
    });
  }
}

export default TestimonialsSlider;
